// Source: app/scripts/controllers/auction-news-item.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('AuctionNewsItemController', [
  '$scope',
  '$filter',
  'toaster',
  'Attachment',
  'Downloader',
  function ($scope, $filter, toaster, Attachment, Downloader) {

    $scope.download = function (entity) {
      Attachment.getAttachmentsByObjectId({
        id: entity.id,
        bean: 'auction_news_attachment'
      }, function (data) {
        if (data && data.length > 0) {
          Downloader.download('/data/rest/attachments/' + data[0].id);
        } else {
          toaster.pop('error', $filter('translate')('generic.error'),
            $filter('translate')("eauction.no_auction_news_attachment"));
        }
      });
    }
  }
])
